export default "__VITE_ASSET__fb7aed47__"